import { Invitation } from '@/types/invitation';
import { api } from './client';
import { GetCodeError, GetCodeSuccess, SubmitCodeError, SubmitCodeSuccess, SubmitPiiError, SubmitPiiSuccess } from '@/types/auth';
import axios, { AxiosError } from 'axios';

async function requestHandler<R, E>(fn: () => Promise<R>) {
  try {
    return fn();
  } catch (error) {
    if (axios.isAxiosError<E>(error)) {
      throw error.response.data;
    }
  }
}

export const authApi = {
  requestCode: async (email: string, accountId?: string, isInvitationFlow: boolean = false): Promise<number> => {
    let body: any = {};

    if (accountId) {
      body.account_id = accountId;
    } else {
      body.email = email;
    }
    body.is_invitation_flow = isInvitationFlow;

    try {
      const resp = await api.post(`/api/v1/auth/request-code`, body);
      return resp.status;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        throw e.response.status;
      }
    }
  },

  submitCode: async (email: string, code: string, accountId?: string): Promise<string> => {
    return await requestHandler<string, SubmitCodeError>(async () => {
      let body: any = {};

      if (accountId) {
        body.account_id = accountId;
      } else {
        body.email = email;
      }
      body.code = code;

      const resp = await api.post<string>(`/api/v1/auth/login`, body);
      return resp.data;
    });
  },
}